import { combineEpics, Epic, ofType } from 'redux-observable'
import { ignoreElements, tap } from 'rxjs/operators'

import { AppProviders } from '../../app.module'

import I18nActions, { CHANGE_LANG, ChangeLangAction } from './i18n.actions'
import { GET_LOOKUPS_SUCCESS, GetLookupsSuccessAction } from './lookup.actions'

export const changeLangEpic: Epic<I18nActions, any, AppProviders> = (actions$, _, { i18nService }) =>
  actions$.pipe(
    ofType<I18nActions, ChangeLangAction>(CHANGE_LANG),
    tap(({ payload }) => i18nService.changeLanguage(payload)),
    ignoreElements()
  )

export const setNewKeysLangEpic: Epic<any, any, AppProviders> = (actions$, _, { i18nService }) =>
  actions$.pipe(
    ofType<GetLookupsSuccessAction>(GET_LOOKUPS_SUCCESS),
    tap(({ payload }) => {
      return [
        i18nService.setNewLanguageKeys(payload.lookups.locales, payload.langCode),
        i18nService.setDateFormatPatterns(payload.langCode),
      ]
    }),
    ignoreElements()
  )

export default combineEpics(changeLangEpic, setNewKeysLangEpic)



// WEBPACK FOOTER //
// ./src/app/core/store/i18n.epics.ts